(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var overlay = document.querySelector('[data-live-demo-overlay]');
    if (!overlay) return;

    var frame = overlay.querySelector('[data-live-demo-frame]');
    var image = overlay.querySelector('[data-live-demo-image]');
    var titleEl = overlay.querySelector('[data-live-demo-title]');
    var openTab = overlay.querySelector('[data-live-demo-open-tab]');
    var deviceButtons = overlay.querySelectorAll('[data-live-demo-device]');
    var closeButton = overlay.querySelector('[data-live-demo-close]');
    var lastFocused = null;
    var sources = { desktop: '', mobile: '' };
    var currentMode = 'desktop';

    function setDevice(mode) {
      currentMode = mode === 'mobile' ? 'mobile' : 'desktop';
      frame.classList.toggle('is-mobile', currentMode === 'mobile');
      if (image && sources[currentMode]) {
        image.src = sources[currentMode];
      }
      frame.scrollTop = 0;
      deviceButtons.forEach(function (btn) {
        var active = btn.getAttribute('data-live-demo-device') === currentMode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
    }

    function openOverlay(trigger) {
      var url = trigger.getAttribute('data-demo-url');
      var desktopSrc = trigger.getAttribute('data-demo-desktop');
      var mobileSrc = trigger.getAttribute('data-demo-mobile') || desktopSrc;
      var title = trigger.getAttribute('data-demo-title') || '';
      var isFull = trigger.getAttribute('data-demo-full') === 'true';
      if (!desktopSrc) return;

      sources.desktop = desktopSrc;
      sources.mobile = mobileSrc;
      frame.classList.toggle('is-full-preview', isFull);
      lastFocused = document.activeElement;
      if (titleEl) titleEl.textContent = title;
      if (openTab) {
        if (url) {
          openTab.href = url;
          openTab.hidden = false;
        } else {
          openTab.hidden = true;
        }
      }
      setDevice('desktop');
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeButton) closeButton.focus();
    }

    function closeOverlay() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-live-demo-link]') : null;
      if (trigger) {
        if (trigger.getAttribute('data-embedded-demo')) {
          return;
        }
        event.preventDefault();
        openOverlay(trigger);
        return;
      }
      if (event.target.closest && event.target.closest('[data-live-demo-close]')) {
        closeOverlay();
        return;
      }
      if (event.target === overlay) {
        closeOverlay();
      }
    });

    deviceButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setDevice(btn.getAttribute('data-live-demo-device'));
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) closeOverlay();
    });
  });
})();
